import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTitle } from './PageTitle';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-267">
      <PageTitle data-id="element-268" />
      <TopBar data-id="element-269" />
      <Header data-id="element-270" />
      <main className="flex-1" data-id="element-271">
        <Outlet data-id="element-272" />
      </main>
      <Footer data-id="element-273" />
    </div>;
}